import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import ArrowImage from "@PUBLIC/P/images/btn/btn_arrow.png";
import imgButton from "@PUBLIC/P/images/btn/btn_spr.png";

const Wrap = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	margin: 0px auto;
	z-index: 101;
	background-color: rgba(0, 0, 0, 0.6);
	animation: fadeIn 0.3s ease forwards;
`;

const Popup = styled.div`
	position: relative;
	top: 50%;
	left: 50%;
	width: 990px;
	height: 680px;
	background: #fff;
	transform: translate(-50%, -50%);
	transition: visibility 0.3s ease-out;
	box-sizing: border-box;
`;

const Header = styled.div<{line?: boolean}>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 70px;
	margin: 0 40px;
	border-bottom: ${({line = true}) => (line ? `1px solid #222` : `none`)};
	box-sizing: border-box;

	h3 {
		color: var(--emp-color);
		font-size: 22px;
		font-family: "pr-font-medium";
		line-height: 1;
	}
`;

const PostMeta = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	min-height: 60px;
	border-bottom: 1px solid #222;

	h4 {
		display: flex;
		align-items: center;
		gap: 10px;
		padding-right: 10px;
		flex: 1;
		font-size: 16px;
		color: var(--emp-color);
	}
`;

const User = styled.span`
	color: var(--emp-color);
`;

const Date = styled.span`
	margin-left: 20px;

	&::before {
		display: inline-block;
		width: 1px;
		height: 11px;
		margin-right: 20px;
		background: var(--bl-color);
		content: "";
	}
`;

const Content = styled.div`
	height: 610px;
	padding: 0 23px 0 40px;
	overflow-y: auto;
	scrollbar-gutter: stable;
`;

const DetailContent = styled.div`
	display: flex;
	gap: 20px;
	padding: 0 0 40px 40px;
`;

const EditorWrap = styled.div`
	padding: 40px 20px 20px;
	min-height: 472px;
	border-bottom: 1px solid var(--line-color);
	box-sizing: border-box;

	img {
		max-width: 700px;
	}
`;

const ReportWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;
	padding: 14px 20px 40px;
`;

const InfoText = styled.p`
	position: relative;
	padding-left: 27px;
	font-size: var(--basic-size);

	&::before {
		position: absolute;
		top: 2px;
		left: 0;
		display: inline-block;
		width: 18px;
		height: 18px;
		background: url(${SpriteImage}) no-repeat 0 -287px;
		vertical-align: middle;
		content: "";
	}
`;

const ReportBtn = styled.button`
	background-color: transparent;
	border-bottom: 1px solid var(--emp-color);
	font-size: var(--basic-size);
	font-family: "pr-font-regular";
	color: var(--emp-color);
	line-height: 1;
`;

const SlideButton = styled.button<{direction?: string}>`
	position: absolute;
	top: 50%;
	width: 20px;
	height: 40px;
	background-color: transparent;
	background-image: url(${ArrowImage});
	background-repeat: no-repeat;
	transform: translateY(-50%);

	${props =>
		props.direction === "next" &&
		`
			right: -40px;
			background-position: -74px 0;

			&:hover {
				background-position: -24px 0;
			}

		`}
	${props =>
		props.direction === "prev" &&
		`
			left: -40px;
			background-position: -50px 0;

			&:hover {
				background-position: 0 0;
			}
		`}
`;

const Gallery = styled.ul`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	grid-gap: 9px;
	padding-bottom: 40px;
`;

const GalleryItem = styled.a`
	position: relative;
	display: block;

	img {
		width: 100%;
	}

	span {
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 26px;
		height: 25px;
		color: #fff;
		font-size: var(--basic-size);
		background-color: rgba(0, 0, 0, 0.6);
	}
`;

const Media = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 450px;
	height: 570px;
	background-color: var(--emp-color);
	box-sizing: border-box;

	> div {
		width: 100%;
		background-color: var(--emp-color);
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	iframe {
		border: none;
	}
	.fallback_thumb {
		background-color: #eee;
	}
`;

const PreviewList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 2px;
	width: 440px;
	padding-bottom: 20px;
	margin-right: 40px;
	border-bottom: 1px solid var(--line-color);
`;

const PreviewItem = styled.li<{$isSelected: boolean}>`
	position: relative;
	height: 42px;
	width: 42px;
	cursor: pointer;
	background-color: #222;

	img {
		height: 100%;
		width: 100%;
	}

	&:after {
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 100%;
		background-color: rgba(255, 255, 255, 0.5);
		content: "";
	}

	${props =>
		props.$isSelected &&
		`
		&:after {
			display: none;
		}
	`}
`;

const ReviewTopBar = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 20px;
	line-height: 1;
`;

const ReviewerProfile = styled.div`
	display: flex;
	gap: 20px;
`;

const UserName = styled.span`
	color: var(--emp-color);
`;

const ProfileDetails = styled.div`
	span:not(:first-child) {
		position: relative;
		padding-left: 10px;
		margin-left: 10px;

		&:before {
			position: absolute;
			top: 50%;
			left: 0;
			display: inline-block;
			width: 3px;
			height: 3px;
			background-color: var(--line-color);
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const ScoreWrap = styled.div`
	em {
		margin-left: 10px;
		font-size: 16px;
		font-family: "pr-font-bold";
		color: var(--emp-color);
	}
`;

const DetailDate = styled.time`
	font-size: var(--basic-size);
`;

const Highlights = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 18px;
`;

const HighlightItem = styled.li`
	display: flex;
	align-items: center;
	height: 28px;
	padding: 0 20px;
	background-color: var(--disabled-color);
	border-radius: 4px;
	font-size: var(--basic-size);
	box-sizing: border-box;
`;

const ReviewText = styled.p`
	margin: 15px 0 36px;
	letter-spacing: 0.015em;
`;

const ReviewInfo = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-right: 25px;
	margin-top: 20px;
	overflow-y: auto;
	scrollbar-gutter: stable;
`;

const ReviewContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 570px;
`;

const FeedbackControls = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: auto;
	line-height: 1;
`;

const RecommendBtnWrap = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	padding-left: 30px;
`;

const RecommendBtn = styled.button`
	position: relative;
	display: block;
	margin-right: 10px;
	background-color: #fff;
	font-family: "pr-font-regular";
	font-size: var(--basic-size);
`;

const RecommendBtnIcon = styled.span<{$isActive?: boolean}>`
	position: absolute;
	top: -2px;
	left: 0;
	display: inline-block;
	width: 21px;
	height: 18px;
	background: transparent url(${imgButton}) 0 -18px / 93px 40px;
	cursor: pointer;

	${props =>
		props.$isActive &&
		`
		background: transparent url(${imgButton}) -22px -18px / 93px 40px;
	`}
`;

const LikeCount = styled.span`
	font-size: var(--basic-size);
`;

const ListLink = styled.a`
	position: relative;
	display: block;
	padding-right: 13px;
	font-size: var(--basic-size);
	line-height: 1;

	&:after {
		position: absolute;
		right: 1px;
		bottom: 0;
		width: 6px;
		height: 6px;
		border-top: 1px solid var(--default-color);
		border-left: 1px solid var(--default-color);
		transform: translate(-50%, -50%) rotate(135deg);
		content: "";
	}
`;

const BestTag = styled.span`
	display: inline-block;
	flex: 0 0 auto;
	height: 20px;
	line-height: 20px;
	padding: 0 8px;
	border: 1px solid var(--red-color);
	border-radius: 10px;
	background-color: #fff;
	font-size: var(--small-size);
	color: var(--red-color);
	text-align: center;
`;

export {
	Wrap,
	Popup,
	Header,
	PostMeta,
	User,
	Date,
	Content,
	EditorWrap,
	ReportWrap,
	InfoText,
	ReportBtn,
	SlideButton,
	Gallery,
	GalleryItem,
	Media,
	PreviewList,
	PreviewItem,
	ReviewTopBar,
	ReviewerProfile,
	UserName,
	ProfileDetails,
	ScoreWrap,
	DetailDate,
	Highlights,
	HighlightItem,
	ReviewText,
	ReviewInfo,
	DetailContent,
	ReviewContent,
	FeedbackControls,
	RecommendBtn,
	RecommendBtnIcon,
	RecommendBtnWrap,
	LikeCount,
	ListLink,
	BestTag,
};
